module.exports = __webpack_public_path__ + "static/media/Test30.d5109a46.bmp";